import {
  CloseButton,
  StyledModalBody,
  StyledModalFooter,
  StyledModalHeader,
  BodyContentWrapper,
} from "../styled";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import DogeBox from "../DogeBox";
import {
  ButtonWrapper,
  MintInfo,
  StyledCheckBox,
  TermsText,
  LoadingCircle,
  LoadingWrapper,
  DogeHead,
} from "./styled";
import { Flex } from "Element/Flex";
import { PrimaryButton, SecondaryButton } from "Element/Button";
import { handleModalClose } from "state/modalSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import dogeHeadSrc from "assets/logo/logo.svg";
// import { motion, Variants, AnimatePresence } from "framer-motion";
import MintedList from "./MintedList";

// const random: Variants = {
//   hidden: {
//     x: "-100vw",
//   },
//   visible: {
//     x: "0",
//     transition: {
//       delay: 0,
//       type: "spring",
//       damping: 10,
//       stiffness: 500,
//     },
//   },
//   exit: {
//     x: "100vw",
//   },
// };

const MintModal = () => {
  const dispatch = useDispatch();
  const [mintLoading, setMintLoading] = useState(false);
  const [successMint, setSuccessMint] = useState(false);

  const handleMint = () => {
    setMintLoading(!mintLoading);
  };

  return (
    <>
      <StyledModalHeader>
        <CloseButton onClick={() => dispatch(handleModalClose())}>
          <CloseIcon />
        </CloseButton>
        <h1>MINT YOUR DOGE</h1>
      </StyledModalHeader>
      <StyledModalBody>
        {!mintLoading ? (
          <div>
            <BodyContentWrapper>
              <DogeBox />
              <MintInfo>
                Mint your Doge with 0.8 ETH, you can mint doge with a maximum
                amount of 20 Doge.
              </MintInfo>
            </BodyContentWrapper>
            <StyledModalFooter>
              <Flex alignItems="center" justifyContent="center">
                <StyledCheckBox type="checkbox" />
                <TermsText />
              </Flex>
              <ButtonWrapper mt={6} mb={10} justifyContent="center">
                <SecondaryButton className="second-btn">
                  GET MORE ETH
                </SecondaryButton>
                <PrimaryButton onClick={handleMint}>BUY DOGE NOW</PrimaryButton>
              </ButtonWrapper>
            </StyledModalFooter>
          </div>
        ) : !successMint ? (
          <div>
            <BodyContentWrapper>
              <LoadingWrapper justifyContent="center" mb={14}>
                <DogeHead src={dogeHeadSrc} />
                <LoadingCircle />
              </LoadingWrapper>
            </BodyContentWrapper>
            <StyledModalFooter>
              <ButtonWrapper justifyContent="center" mb={10}>
                <SecondaryButton
                  className="second-btn"
                  onClick={() => setMintLoading(!mintLoading)}
                >
                  cancel
                </SecondaryButton>
              </ButtonWrapper>
            </StyledModalFooter>
          </div>
        ) : (
          <>
            <MintedList />
            <StyledModalFooter>
              <MintInfo style={{ marginBottom: 24 }}>
                Your minting success, you’ve got 20 Doge NFT here.
              </MintInfo>
              <ButtonWrapper justifyContent="center" mb={10}>
                <SecondaryButton
                  className="second-btn"
                  onClick={() => setMintLoading(!mintLoading)}
                >
                  go back to home
                </SecondaryButton>
              </ButtonWrapper>
            </StyledModalFooter>
          </>
        )}
      </StyledModalBody>
    </>
  );
};

export default MintModal;
